module.exports = {
  homepage: {
    heroTitle1: "SmartTeamDev",
    heroTitle2: "Corporate web solutions for manufacturing companies",
    heroSubtitle: "We design, implement and support digital systems for daily operations: document flow, integrations, automation, and analytics.",
    marqueeText: "Reliability • Security • Support • Portals • Cloud • Network • Integrations •",
    heroPrimaryBtn: "Portal page",
    heroSecondaryBtn: "Contact",
    btnLearnPortal: "Portal page",
    btnContact: "Contact",
    scrollDown: "Learn more",
    whatYouGetEyebrow: "What you get",
    whatYouGetTitle: "Ready-made solutions that accelerate your team's work",
    whatYouGetDesc: "We build projects that are easy to adopt, scale and run with minimal downtime.",
    card1Title1: "Portal as a control center",
    card1Desc1: "A single access point for employees, business units and external partners.",
    card1Title2: "Task automation",
    card1Desc2: "Workflows, notifications and event handlers operate automatically while you grow your business.",
    card1Back: "Measurable results: less manual work, faster decisions, transparent control.",
    card2Title1: "A network that doesn't fail",
    card2Desc1: "Thoughtful architecture for stable and secure corporate infrastructure.",
    card2Title2: "Cloud and hybrid",
    card2Desc2: "Flexible solutions that work both in cloud and on-premise environments.",
    card2Back: "Support at every stage: from launch to scaling and maintenance.",
    card3Title1: "Security and control",
    card3Desc1: "Advanced approaches to access, encryption and IT compliance.",
    card3Title2: "Adaptive support",
    card3Desc2: "Solutions that grow with the business and handle changing requirements.",
    card3Back: "A structure you can rely on: stability, availability and predictability.",
    servicesEyebrow: "Services",
    servicesTitle: "What we do best",
    servicesDesc: "A holistic approach: portals, services, network and cloud platforms for company growth.",
    service1Title: "Corporate portals",
    service1Desc: "Reliable interfaces for internal processes, customers and partners.",
    service2Title: "Cloud platforms",
    service2Desc: "Hybrid and cloud solutions with controlled migration and risk reduction.",
    service3Title: "Information security",
    service3Desc: "Data protection, access control and compliance with infrastructure requirements.",
    contactEyebrow: "Contact us",
    contactTitle: "Tell us about your task, we'll propose a solution",
    contactDesc: "We design an architecture ready for change without unnecessary technical debt.",
    contactHighlight1Value: "18 years",
    contactHighlight1Label: "of experience in corporate solutions",
    contactHighlight2Value: "24/7",
    contactHighlight2Label: "monitoring and support",
    placeholderName: "Name",
    placeholderEmail: "Email",
    placeholderPhone: "Phone",
    placeholderMessage: "Describe your task",
    contactBtn: "Send request",
    heroStats: [
      { riIcon: "RiBriefcase4Line", value: "35+", count: 35, label: "Business apps" },
      { riIcon: "RiPlugLine", value: "10+", count: 10, label: "Integration domains" },
      { riIcon: "RiServerLine", value: "On-premise", label: "Deployment" },
      { riIcon: "RiShieldCheckLine", value: "Role-based", label: "Access control" }
    ],
    aboutTitle: "Who we are",
    aboutLead: "SmartTeamDev is a team of corporate web-system developers for industrial enterprises.",
    aboutText: "We build and deploy digital tools that run in the client's own infrastructure: on-premise portals, business applications, integrations and services. Our expertise is manufacturing and industrial companies where reliability, data control and flexibility matter most.",
    aboutPoints: [
      "Full-cycle team: analysis, development, implementation, support",
      "On-premise first — your data stays with you",
      "Specialised in manufacturing and industrial enterprises",
      "Own Portal platform with 35+ ready-to-use applications"
    ],
    areasTitle: "What we build",
    areasSubtitle: "Three practical directions that cover a complete digitalisation cycle",
    companyAreas: [
      {
        href: "/pages/portal",
        riIcon: "RiLayoutGridLine",
        title: "Corporate portal",
        description: "Single work environment for teams: documents, tasks, data and services in one interface.",
        features: ["Desktop /app", "AD role model", "Modular apps/* structure"]
      },
      {
        href: "/pages/services",
        riIcon: "RiPlug2Line",
        title: "Development and integrations",
        description: "We connect 1C, banks, AD, ACS, FortMonitor, messengers and external APIs into one workflow.",
        features: ["REST and proxy integrations", "Scheduled synchronisation", "Logging and audit"]
      },
      {
        href: "/pages/media",
        riIcon: "RiFileList3Line",
        title: "Demo and documentation",
        description: "We present real scenarios and architecture decisions for specific modules and user roles.",
        features: ["Demo scenarios", "Technical materials", "Implementation plan"]
      }
    ],
    factsTitle: "Why SmartTeamDev",
    factsSubtitle: "Criteria that matter for production-grade operation",
    companyFacts: [
      {
        riIcon: "RiLock2Line",
        title: "Data control",
        description: "The platform runs in your own perimeter without mandatory cloud dependencies."
      },
      {
        riIcon: "RiStackLine",
        title: "Extensible architecture",
        description: "New modules are connected declaratively without reworking the whole platform."
      },
      {
        riIcon: "RiShieldCheckLine",
        title: "Transparent permissions",
        description: "Access is controlled by roles, AD groups, and server-side filters on apps and databases."
      },
      {
        riIcon: "RiSettings3Line",
        title: "Support",
        description: "We provide updates, customisation and operational support after go-live."
      }
    ],
    releaseTitle: "How we deliver to production",
    releaseSteps: [
      { num: "01", riIcon: "RiSearchLine", title: "Discovery", text: "We define processes, user roles, data sources, and required integrations." },
      { num: "02", riIcon: "RiGitMergeLine", title: "Design", text: "We prepare module scope, permission matrix, integration model and rollout plan." },
      { num: "03", riIcon: "RiServerLine", title: "Implementation", text: "We deploy the platform, migrate settings, connect services and train your team." },
      { num: "04", riIcon: "RiPulseLine", title: "Operation", text: "We keep the system stable and continue feature development according to needs." }
    ],
    techTitle: "Technology stack",
    techSubtitle: "Platform components used in production",
    techStack: [
      { riIcon: "RiReactjsLine", title: "Frontend", text: "React 18, Redux Toolkit, Ant Design 5, desktop routing and widgets." },
      { riIcon: "RiNodejsLine", title: "Backend", text: "Node.js 20+, Express, socket.io, EJS and application APIs for apps/*." },
      { riIcon: "RiDatabase2Line", title: "Data", text: "MongoDB with system and business data separation, Mongoose and server-side filters." },
      { riIcon: "RiSettings4Line", title: "Integrations", text: "AD/LDAP, 1C, banking APIs, DaData, Kontur.Focus, FortMonitor, WOPI and OpenAI." }
    ],
    ctaTitle: "Discuss your project",
    ctaSubtitle: "We will prepare module scope, integration map and implementation plan for your organisation.",
    ctaContactBtn: "Write to us",
    ctaLearnMoreBtn: "Open Portal"
  }
};
